import React from "react";
import "./services.css";


const Services = () => {
  return (
    <section id="services" data-aos="zoom-out-up">
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className="container services_container">
        <article className="services">
          <div className="service_head">
            <h3>Content Creation</h3>
          </div>
          <ul className="service_list">
            <li>

               <p> ☑️ Well here's the truth , you can't upload a "Wah bete mauj kardi " meme in 2023 , nobody's gonna watch it . I will help you discover valuable trending content for your brand to stay relevant. </p>
            </li>
            <li>

               <p> ☑️ I will create content relevant to your audience which will help your brand gain more traction organically .</p>
            </li>
            <li>

               <p> ☑️ I will collaborate with influencers in your niche to reach the millions waiting. </p>
            </li>
          </ul>
        </article>
        <article className="services">
          <div className="service_head">
            <h3>Web Development</h3>
          </div>
          <ul className="service_list">
            <li>

               <p> ☑️ I can build web apps using React, Express or MongoDB.</p>
            </li>
            <li>

               <p> ☑️ I can create different types of websites like Ecommerce Applications ,Social Media Websites , Food Websites, Gym Websites and Many More According to your Needs.</p>
            </li>
            <li>

               <p> ☑️ Developing an effective web presence is imperative for sustainable business growth. I provide my clients with very attractive, effective and responsive websites. </p>
            </li>
          </ul>
        </article>
        <article className="services">
          <div className="service_head">
            <h3>UI/UX Design</h3>
          </div>
          <ul className="service_list">
            <li>

               <p> ☑️  I can design a website according to your needs . After all You Are The Real Owner .</p>
            </li>
            <li>
               <p> ☑️ I help to boost business growth by improving  the visuals appeals on the websites like different color selections,fonts or the complete layout of the website .</p>
            </li>
            <li>
               <p> ☑️  I improve user interaction  and customer satisfaction .</p>
            </li>
          </ul>
        </article>       
      </div>
    </section>
  );
};

export default Services;
